<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">BID WANTED SEND TO ECN</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                        <h6 class="d-flex justify-content-left">ECN Status</h6>
               <div class="inventory-legend">
                          <span class="legend-color dark-green-legend" title="All ECN Sent"></span>
                          <!-- <span class="legend-color light-green-legend" title="Partial ECN Sent"></span> -->
                          <span class="legend-color dark-blue-legend" title="All Operator Sent"></span>
                          <!-- <span class="legend-color light-blue-legend" title="Partial Operator Sent"></span> -->
                          <span class="legend-color pink-orange" title="Inventory Offer Exists"></span>
                        </div>
                        </div>
            <!-- <h4 style="color:#1c91d2">{{cusipName}}</h4>
            <h5 style="color:rgb(69 69 69)">{{cusipDes}}</h5> -->
            <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
            <thead class="thead-light psticky">
                <tr>
                    <th scope="col">CUSIP/DESC</th>
                    <th scope="col" class="text-left">CUSTOMER <br>ACCOUNT | TYPE</th>
                    <th scope="col">BOUGHT</th>
                    <th scope="col">COST</th>
                    <th scope="col">QTY</th>
                    <th scope="col">AVLB QTY</th>
                    <th 
                        scope="col" 
                        class="sort text-left"
                        >SELL QTY</th> 
                    <th 
                    scope="col" 
                    class="sort text-left"
                    >SPREAD</th>
                    <th scope="col">ACTION</th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="(holding,index) in localHolding" :key="holding.inventoryId"  >
                     <td class="text-center">
                        <span class="cusip-highlight" :class="getRowColor(holding.highlightColor)">{{holding.cusipVal}}</span><br>
                        <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                    </td>
                    <td class="text-left">
                        <span class="">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                        <span>{{holding.accountVal}}</span> | 
                        <span class="">{{holding.accountType}}</span> 
                    </td>
                    <td class="text-center">
                        <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                    </td>
                    <td class="text-center"><span>{{holding.cost | currency}}</span></td>
                    <td class="text-center">
                        <span>{{holding.quantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span v-if="!isTraderDirectSendToEcn && !isOperatorDirectSendToEcn">{{holding.availableQuantity }}</span>
                        <span v-else>{{holding.remainQuantity }}</span><br>

                    </td> 
                    <td class="text-center">
                        <span class="sell-qty"><input type="number"  class="form-control" placeholder="Qty"  v-model.number="holding.sellQuantity"></span><br>
                    </td> 
                    <td class="text-center">
                        <span class="sell-qty"><input type="number" @change="setSpread(holding.spread,holding.customerId)" class="form-control" placeholder="Spread"  v-model.number="holding.spread"></span><br>
                    </td> 
                    <td @click="deleteHolding(index,holding)">
                        <span class="cursor-pointer">
                          <i class="far fa-trash-alt"></i>
                        </span>
                    </td>
                </tr>    
                
            </tbody>
            </table> 
            <form  @submit.prevent="">
                <div class="form-row">
                    <!-- <div class="form-group col-md-6 required">
                        <label for="inputLast">Quantity</label>
                        <input 
                            type="number" 
                            class="form-control" 
                            id="inputLast" 
                            placeholder="Quantity" 
                            v-model="sellQuantity" 
                        >
                    </div> -->
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Valid Until Time</label>
                        <ValidTime v-model="validTime"  v-bind:defaultTime="defaultValidUntilTime" />
                    </div>
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Firm Until Time</label>
                        <ValidTime v-model="firmUntilTime" v-bind:defaultTime="defaultFirmUntilTime"/>
                    </div>
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Settlement Date</label>
                        <DatePicker :disabledDates="disabledDatesSettlement"  v-model="settlementDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></DatePicker>
                    </div>
                    
                </div> 
                <div class="form-row">
                    <!-- <div class="form-group col-md-6 required">
                        <label for="inputLast">Settlement Date</label>
                        <DatePicker :disabledDates="disabledDatesSettlement"  v-model="settlementDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></DatePicker>
                    </div> -->
                    
                </div>   
                <!-- <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputLast">Spread</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="inputLast" 
                            placeholder="spread" 
                            v-model="spread" 
                            maxlength="5"
                            @keypress="isNumber($event)"
                        >
                    </div>
                </div>        -->
            </form>   
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div>
                <span v-if="isUploadInProgress()" class="alert alert-danger" role="alert">
                    Holding upload is currently in progress. Please try again once it’s complete.
                </span>
            </div>
            <br>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button :disabled="isUploadInProgress() || !settlementDate || holding.length == 0"  @click="sendToEcn()" type="button" class="btn btn-success" >SEND TO ECN</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
// import HoursPicker from "@/components/common/HoursPicker"
import ValidTime from "@/components/common/ValidTime"
import DatePicker from 'vuejs-datepicker';
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'createbidwanted',
    props: ['holding','isTraderDirectSendToEcn','isOperatorDirectSendToEcn'],
    components :{
        // HoursPicker,
        DatePicker,
        ValidTime
    },
    data() {
        return {
            validTime: "",
            sellQuantity : "",
            settlementDate: "",
            disabledDatesSettlement: {
                to : this.getYestedayDate()
            },
            firmUntilTime:"",
            userSettings : null,
            defaultValidUntilTime : "",
            defaultFirmUntilTime : "",
            spread :  "",
            isOperatorPage : window.location.pathname.includes("/bidaccumulator/operator"),
            loading : false,
            // cusipName : this.localHolding ? this.localHolding[0].cusipVal : "",
            // cusipDes : this.localHolding ? this.localHolding[0].cusipDescription : "",
            deletedBidWantedIds : [],
            localHolding : [],

        }

    },
    methods:{
        setSpread(spread,customerId){
            if(customerId){
                this.localHolding.forEach((element) => {
                    if(element.customerId == customerId){
                        element.spread = spread
                    }
                });
            }
        },
        deleteHolding(holdingIndex,holding){
            var message = `Are you sure you want to delete?`;
            this.$confirm(message,"","question",{confirmButtonText:"DELETE",cancelButtonText : "NO"}).then(() => {
                this.localHolding.splice(holdingIndex,1);
                if(!this.isTraderDirectSendToEcn){
                    this.deletedBidWantedIds.push(holding.inventoryId)
                }
            })
        },
        getOrganizationSetting(){
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/organization/bid-settings?type=OFFER",
                auth
              )
              .then(response => {
                this.settlementDate = response.data.settlementDate;
              })
        },
        checkValid(){
            let isValid = true;
            let cusipType = this.localHolding[0].offeringTypeId === 1 ? "Munis" : "Corporates";
            this.localHolding.forEach((holding) => {
                if(!holding.sellQuantity){
                    isValid = false;
                    this.$alert("Fill all holdings sell quantity","","error");
                    return;
                 }
                if(holding.remainQuantity < holding.sellQuantity){
                    isValid = false;
                    this.$alert("Quantity entered is greater than available quantity.","","error");
                    return;
                 }
                if(cusipType == 'Munis' &&  holding.sellQuantity % 5 != 0 ){
                    isValid = false;
                    this.$alert("Holding quantity is not multiples of 5","","error");
                    return ;
                }
                if(!this.validTime){
                    isValid = false;
                    this.$alert("Valid time is required","","error");
                    return ;
                }
                if(!this.firmUntilTime){
                    isValid = false;
                    this.$alert("Firm Until is required","","error");
                    return ;
                }
            });
            return isValid
        },
        sendToEcn(){
            if(this.checkValid()){
                var beginningTime = this.moment(this.moment.utc(this.validTime).local().format("h:mma"), 'h:mma');
                var endTime = this.moment(this.moment.utc(this.firmUntilTime).local().format("h:mma"), 'h:mma');
                console.log(beginningTime,endTime)
                if(beginningTime.isAfter(endTime) || beginningTime.isSame(endTime)){
                    this.$alert("Firm Until Time should be always higher than valid until time","","error");
                    return ;
                }
                var message = `Are you sure you want to send this bid wanted to ECN?`;
                this.$confirm(message,"","question",{confirmButtonText:"SEND TO ECN",cancelButtonText : "NO"}).then(() => {
                        this.loading = true;
                        const auth = {
                            headers: { 'org-token' : authService.getOrgToken()  }
                        };
                        let traderCongnitoSub = null;
                        if(this.isTraderDirectSendToEcn){
                            traderCongnitoSub = authService.getUser().cognitoSub;
                        }
                        if(!this.isTraderDirectSendToEcn){
                            traderCongnitoSub = this.localHolding[0].traderCognitoSub;
                        }
                        if(this.isOperatorDirectSendToEcn){
                            traderCongnitoSub = null;
                        } 
                        let bidWantedData  = [];
                        // Group by cusipId AND accountId so each entry holds bid wanteds of the same account.
                        const groupMap = {};
                        this.localHolding.forEach((holding) => {
                            const groupKey = holding.cusipId + "-" + holding.accountMappingId;
                            if(!groupMap[groupKey]){
                                groupMap[groupKey] = {"id": null,"cusipId": holding.cusipId,"bidWantedHoldingDtos":[]};
                                bidWantedData.push(groupMap[groupKey]);
                            }
                            const data = groupMap[groupKey];
                            if(!this.isTraderDirectSendToEcn && !this.isOperatorDirectSendToEcn){
                                data.id = holding.id;
                                data.bidWantedHoldingDtos.push({accountId : holding.accountMappingId,inventoryId : holding.inventoryId,quantity : holding.sellQuantity,spread : holding.spread})
                            }else{
                                data.bidWantedHoldingDtos.push({accountId : holding.accountMappingId,inventoryId : holding.id,quantity : holding.sellQuantity,spread : holding.spread})
                            }
                        })
                        console.log(bidWantedData)
                        let data = {
                            "traderCognitoSub":traderCongnitoSub,
                            "operatorCognitoSub": this.isTraderDirectSendToEcn ? null : authService.getUser().cognitoSub,
                            "status": "NEW",
                            "expireMinutes": this.validTime,
                            "settlementDate": this.moment(this.settlementDate).format("MM/DD/YYYY"),
                            "firmUntilMinutes" : this.firmUntilTime,
                            "bidWanted" : bidWantedData
                            }
                        this.$http
                        .post(config.baseUrlBidSide + "/bidwanted/send-to-ecn",data,auth)
                        .then((response) => {
                            this.loading = false;
                            const res = response.data || {};
                            const colorMap = res.bidwantedColorMapList || {};
                            // Keep only holdings present in bidwantedColorMapList (keys are inventoryId); remove the rest.
                            this.localHolding = this.localHolding.filter(holding =>
                                colorMap[holding.inventoryId] !== undefined || colorMap[holding.id] !== undefined
                            );
                            // Update row colors returned from the server (keys are inventoryId)
                            this.localHolding.forEach(holding => {
                                const color = colorMap[holding.inventoryId] || colorMap[holding.id];
                                if(color){
                                    this.$set(holding, 'highlightColor', color);
                                }
                            });
                            // Re-sort so highlighted (colored) records stay on top
                            const isHighlighted = h => h.highlightColor && h.highlightColor !== "NO_COLOR" ? 1 : 0;
                            this.localHolding.sort((a, b) => isHighlighted(b) - isHighlighted(a));

                            if(res.failedSentBidwantedCount > 0){
                                // Some bid wanteds could not be sent to ECN — keep the popup open so the user can review the highlighted rows.
                                this.$alert(res.failedSentBidwantedCount + " bid wanted(s) could not be sent to ECN. Please review the highlighted holdings.","","warning");
                            }else{
                                this.$alert("Successfully sent to ecn","","success");
                                this.$emit('close');
                            }
                        })
                        .catch(() => {
                            this.loading = false;              
                        });
                    })
            }
            
        },
        getUserSetting(){
            this.loading = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .get(
                config.baseUrlBidSide +
                    "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                    auth
                )
                .then(result => {
                    this.userSettings = result.data;
                    this.userSettings.forEach(element => {
                        if(element.setting == "BW_FIRM_UNTILL_TIME"){
                            this.defaultFirmUntilTime = element.value
                        }
                        if(element.setting == "BW_VALID_UNTILL_TIME"){
                            this.defaultValidUntilTime = element.value
                        }
                        // if(element.setting == "ARBS_SPREAD"){
                        //     this.arbsSpread = element.value
                        // }
                    });
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                });
        },

    },
    mounted(){
        this.getUserSetting();
        this.getOrganizationSetting();
        // this.sellQuantity = this.localHolding.sellQuantity;
        console.log(this.isTraderDirectSendToEcn,this.isOperatorDirectSendToEcn);
          //Resstructured Holdings.

        if(!this.isTraderDirectSendToEcn && !this.isOperatorDirectSendToEcn){
            this.localHolding = this.holding;
        }else{
            this.localHolding = this.holding.flatMap(item =>
            item.invDetails.map(detail => ({
                ...item,
                ...detail,
                sellQuantity : item.invDetails.length > 1 ?  detail.remainQuantity : item.sellQuantity,
               // invDetails: undefined // optional: remove the nested invDetails from the final output
            }))
            );
        }

        // Colored (highlighted) records always on top; sort is stable so the rest keep their order.
        const isHighlighted = h => h.highlightColor && h.highlightColor !== "NO_COLOR" ? 1 : 0;
        this.localHolding.sort((a, b) => isHighlighted(b) - isHighlighted(a));

    }
};
</script>
<style scoped>
.table i {
 color: #E96875 !important; 
}
</style>